import { AuthApi } from '@src/shared/api';
import { ApiError, ValidationCodeData } from '@src/shared/models';
import { pauseLoading, shouldLoading, useAppStore } from '@src/shared/zustand';

export const setToken = (token: string) => useAppStore.setState({ token });

export const generateCode = async (
  email: string,
  callback: (error: ApiError | null) => void
) => {
  shouldLoading();
  try {
    await AuthApi.generateCode({
      data: email,
      type: 'EMAIL',
      function: 'credito-viagem',
      pinCodeExpireTime: 1800000,
    });

    callback(null);
  } catch (error) {
    callback(error);
  } finally {
    pauseLoading();
  }
};

export const validateCode = async (
  req: ValidationCodeData,
  callback: (error: ApiError | null) => void
) => {
  shouldLoading();
  try {
    await AuthApi.validateCode(req);
    callback(null);
  } catch (error) {
    callback(error);
  } finally {
    pauseLoading();
  }
};
